import { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import { toJalaali } from "jalaali-js";

import Top from "./Top";
import Menu from "./Menu";
import TourCarousel from "./TourCarousel";

import "./home.scss";
import image from "../assets/image/jomesob.jpg";

export default function Home() {
  const texts = [
    "سفر یعنی زنده بودن.",
    "زمان کم و دنیا گسترده است.",
    "هر سفر دنیایی از ناشناخته ها در خودش دارد که مسافران از آن بی خبر اند.",
  ];

  const [theTours, setTheTours] = useState([
    {
      type: { id: -1, title: "تور ویژه" },
      tourList: [],
    },
  ]);
  const [specialTours, setSpecialTours] = useState([]);
  const [tags, setTags] = useState([]);

  const settingTours = (data, theTags) => {
    let tours = [],
      theSpecialTours = [];
    theTags.forEach((value) => {
      tours.push({
        type: { id: value.id, title: value.title },
        tourList: [],
      });
    });
    let typeIndex = [];
    data.forEach((value) => {
      typeIndex = [];
      value.tags.forEach((tag) => {
        if (tag.ismain == 1) {
          tours.forEach((val, index) => {
            if (val.type.id == tag.id) {
              typeIndex.push(index);
              return true;
            }
            return false;
          });
        }
      });
      let city = value.city.length > 0 ? value.city[0].title : "";
      let record = {
        id: value.id,
        title: value.title,
        city,
        image:
          value.cover_pic == ""
            ? image
            : `http://mvc.dade24.ir/${value.cover_pic}`,
        start_time: "",
        end_time: "",
        max_participant:
          parseInt(value.public_capacity) -
          parseInt(value.frozen_reserved) -
          parseInt(value.complate_reserved),
        price: value.mainprice,
        essentials: value.essentials_accessories,
      };
      try {
        let start_time = toJalaali(new Date(value.stm * 1000)),
          end_time = toJalaali(new Date(value.ftm * 1000));
        record.start_time = `${start_time.jy}/${
          start_time.jm > 9 ? start_time.jm : "0" + start_time.jm
        }/${start_time.jd > 9 ? start_time.jd : "0" + start_time.jd}`;
        record.end_time = `${end_time.jy}/${
          end_time.jm > 9 ? end_time.jm : "0" + end_time.jm
        }/${end_time.jd > 9 ? end_time.jd : "0" + end_time.jd}`;
      } catch (err) {
        console.log(err);
        console.log(value);
      }
      [...new Set(typeIndex)].forEach((index) => {
        tours[index].tourList.push(record);
      });
      if (value.isspecial == 1) {
        theSpecialTours.push(record);
      }
    });
    console.log(tours);
    setTheTours(tours);
    setSpecialTours(theSpecialTours);
  };

  useEffect(() => {
    async function getInfo() {
      let theTags;
      let formData = new FormData();
      formData.append("fields", "id, title");
      formData.append("conditions", "ismain/=/1");
      await axios
        .post("http://mvc.dade24.ir/api/Find_tour_tags", formData)
        .then((res) => {
          theTags = res.data;
          setTags(theTags);
        });
      await axios.get("http://mvc.dade24.ir/api/fulltour").then((res) => {
        if (res.status == 200) {
          let temp = res.data.data.filter((value) => value.main_status == 4);
          settingTours(temp, theTags);
        }
      });
    }
    getInfo();
  }, []);

  SwiperCore.use([Autoplay]);

  return (
    <div className="the-home home-container">
      {/* <!--flight card--> */}
      <Top />
      <Menu />
      {/* دسته بندی تور ها */}
      {theTours.length > 0 ? (
        <>
          <div className="container mt-4">
            <div className="fw-bolder fs-4 text-color">دسته بندی تورها</div>
            <ul className="nav nav-tabs mb-3 " id="tour-tab" role="tablist">
              {theTours.map((value, index) => (
                <li className="nav-item" role="presentation" key={index}>
                  <button
                    className={`tour nav-link text-dark font-regular ${
                      index === 0 ? "active" : ""
                    }`}
                    id={`tab-${value.type.id}`}
                    data-bs-toggle="tab"
                    data-bs-target={`#content-${value.type.id}`}
                    type="button"
                    role="tab"
                    aria-controls={`content-${value.type.id}`}
                    aria-selected="false"
                  >
                    {value.type.title}
                  </button>
                </li>
              ))}
            </ul>
            {/* <!-- content tab tour--> */}
            <div className="tab-content" id="tabContent1">
              {/* <!--tab tour iran--> */}
              {theTours.map((value, index) => (
                <div
                  className={`tab-pane fade ${
                    index === 0 ? "show active" : ""
                  } container`}
                  id={`content-${value.type.id}`}
                  role="tabpanel"
                  aria-labelledby={`tab-${value.type.id}`}
                  key={index}
                >
                  <TourCarousel tours={value.tourList} />
                </div>
              ))}
            </div>
          </div>

          {specialTours.length > 0 ? (
            <>
              {/* تور ویژه */}
              <div className="container mt-4">
                <div className="fw-bolder fs-4 text-color"> تور های ویژه </div>
                <TourCarousel tours={specialTours} />
              </div>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      <div className="d-flex justify-content-end">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          loop
          autoplay={{
            delay: 3500,
            pauseOnMouseEnter: false,
          }}
        >
          {texts.map((txt, index) => (
            <SwiperSlide>
              <div className="text-end pe-5 mt-3" key={index}>
                {txt}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
